<template>
    <div>
        <Modal
            v-model="twoIntention"
            :title="steps === 1 ? '提示' : '添加渠道'"
            :mask-closable="false"
            :closable="false">
            <div v-if="twoIntentionData.tips_status === 1">
                <div v-if="steps === 1" style="text-align:center">
                    <p>客户：{{twoIntentionData.name}} {{twoIntentionData.phone}} 已存在于 CRM，</p>
                    <p>当前跟进门店：
                        <span style="color:red">{{twoIntentionData.follow_store_names.join('、')}}</span>
                    </p>
                    <p>是否增加二次渠道，并在 <span style="color:red">{{twoIntentionData.store_name}}</span> 进行回访跟进?</p>
                </div>
            </div>
            <div v-else-if="twoIntentionData.tips_status === 2">
                <div v-if="steps === 1" style="text-align:center">
                    <p>该客户已存在于本店</p>
                    <div class="listItem">
                        <div>当前跟进人：</div>
                        <div>
                            <p
                            v-for="(item,index) in twoIntentionData.follow_list"
                            :key="index">{{item.created_at}}
                             分配给 {{item.follow_department_name}} {{item.follow_user_name}}
                             <span :class="item.follow_status == 4 ? 'colorRed' : ''">
                                 {{item.follow_status_text}}</span>
                             </p>
                        </div>
                    </div>
                    <p>是否需要通过“增加渠道”成为第二录入人？</p>
                    <p><span style="color:red">*第二录入人能看到该客户的回访信息</span></p>
                </div>
            </div>
            <div v-else-if="twoIntentionData.tips_status === 3">
                <div style="text-align:center">
                    <p>客户：{{twoIntentionData.name}} {{twoIntentionData.phone}} 已于
                        <span style="color:red" v-for="(item,index) in twoIntentionData.sign_store_list" :key="index">{{item}}</span>
                        签单若需创建二次签单意向，需完成离院结算</p>
                    <p>系统房态的离院日期为：{{twoIntentionData.leave_time}}</p>
                </div>
            </div>
            <div v-if="steps === 2">
                <Alert type="error">增加渠道会让您成为第二录入人，可查看该客户所有回访信息</Alert>
                <Form ref="formValidate" :model="formItem" :rules="ruleValidate" :label-width="80">
                    <Row>
                        <Col span="14">
                            <FormItem  label="渠道" prop="department_id">
                                <Select v-model="formItem.department_id" placeholder="请选择部门" @on-change="changeChannel">
                                    <Option v-for="item in departmentList" :key="item.id" :value="item.id+''">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="10">
                            <FormItem :label-width="0" prop="channel_id">
                                <Select v-model="formItem.channel_id" filterable placeholder="请选择渠道">
                                    <Option v-for="item in channel" :key="item.id" :value="item.id+''">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <FormItem label="渠道说明" prop="channel_explain">
                                <Input  type="textarea" :maxlength="100" v-model="formItem.channel_explain" :autosize="{minRows: 2,maxRows: 5}" placeholder="请在100字内描述特有的渠道说明"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <FormItem label="备注" prop="remark">
                                <Input type="textarea" :maxlength="200" v-model="formItem.remark" :autosize="{minRows: 2,maxRows: 5}" placeholder="请在200字内描述增加渠道的原因"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <FormItem label="" prop="is_follow">
                                <Checkbox v-model="formItem.is_follow">设自己为跟进人</Checkbox>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button
                :type="twoIntentionData.tips_status === 3 ? 'primary' : 'text'"
                size="large"
                @click="handleCancel">
                {{twoIntentionData.tips_status === 3 ? '确认' : '取消'}}
                </Button>
                <Button
                v-if="twoIntentionData.tips_status != 3"
                type="primary"
                size="large"
                :disabled="disabled"
                @click="handleSubmit('formValidate')">
                {{twoIntentionData.tips_status === 1 || twoIntentionData.tips_status === 2? '添加渠道' : '确认'}}
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:"CRM_twoIntention",
    props:['departmentList','twoIntention','twoIntentionData','type'],
    data(){
        return{
            disabled:false,
            steps:1,
            formItem:{
                department_id:"",
                channel_id:"",
                channel_explain:"",
                remark:"",
                is_follow:false
            },
            ruleValidate: {
                department_id: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                channel_id: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                remark: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { type: 'string', max: 200, message: '超过200字', trigger: 'blur' }
                ]
            },
            channel:[]
        }
    },
    methods:{
        //监听选择渠道部门
        changeChannel(id){
            this.formItem.channel_id = ""
            this.channel = []
            this.apiChannelAll(id)
        },
        //获取渠道
        apiChannelAll(id){
            let url = this.type == 'myCustomer' ? api.myMemberChannelAll : api.memberStoreMemberAll
            serve.fetchGet(url,{department_id:id}).then(data => {
                console.log(data)
                this.channel = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        handleSubmit(name){
            if(this.steps === 1){
                this.steps = 2
            }else{
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true
                        this.apiChannelAdd()
                    } else {
                        this.$Message.error('请完善表单');
                    }
                })
            }
        },
        //请求添加渠道
        apiChannelAdd(){
            let params = {
                member_id:this.twoIntentionData.member_id,
                department_id:this.formItem.department_id,
                channel_id:this.formItem.channel_id,
                channel_explain:this.formItem.channel_explain,
                remark:this.formItem.remark,
            }
            if(this.formItem.is_follow) params.is_follow = 1
            let url = this.type == 'myCustomer' ? api.myMemberSaveChannelInfo : api.memberSaveChannelInfo
            serve.fetchPost(url,params).then(data => {
                console.log(data)
                this.$Message.success('添加成功')
                this.$emit("twoIntentionEven",false,false)
                this.disabled = false
            }).catch((error)=>{
                this.disabled = false
                this.$Message.error(error.response.data.message);
            })
        },
        handleCancel(){
            this.$emit("twoIntentionEven",false)
        },
    },
    watch:{
        //监听模态框显示隐藏
        twoIntention(val){
            if(val){
                this.steps = 1
            }
        }
    }
}
</script>
<style scoped>
    .listItem{
        display:flex;
        display:-webkit-flex;
        justify-content: center;
        margin:10px 0;
    }
    .colorRed{
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_twoIntention.vue